import { Component } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-sme-review-popup',
  templateUrl: './sme-review-popup.component.html',
  styleUrls: ['./sme-review-popup.component.scss'],
    standalone: false
})
export class SmeReviewPopupComponent {
  smeReviewComment: string = '';
  isBulkAction: boolean = false;

  constructor(public dialog: DialogRef) {}

  close(actionName: string): void {
    if (actionName === 'submit') {
      this.dialog.close({
        actionType: actionName,
        comment: this.smeReviewComment,
        bulkAction: this.isBulkAction,
      });
    } else {
      this.dialog.close({
        actionType: actionName,
        comment: '',
        bulkAction: this.isBulkAction,
      });
    }
  }
}
